import {
	ICreateTeaserTotalSchedule,
	TCreateTeaserControlPoint,
	TCreateTeaserSelectedContentType,
	TCreateTeaserSelectedItem,
	TCreateTeaserTransitionType,
	TCreateTeaserVisibleForm,
	TSourceUrlLocally,
	TTypeOfCreateTeaserModalWindow,
} from './createTeaserContext';
import { IItemForGetShortInfo, TFileId, ICreateTeaser } from 'types';

export enum CreateTeaserActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE = 'SET_FILE',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_CUSTOMER = 'SET_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_RESTAURANTS = 'SET_RESTAURANTS',
	SET_CONTENT_TYPE = 'SET_CONTENT_TYPE',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	CHANGE_SCHEDULE = 'CHANGE_SCHEDULE',
	CHANGE_ADDITIONAL_SCHEDULE = 'CHANGE_ADDITIONAL_SCHEDULE',
	SET_SCHEDULES = 'SET_SCHEDULES',
	SET_TRANSITION_TYPE = 'SET_TRANSITION_TYPE',
	SET_FETCHED_DISH_CATEGORIES = 'SET_FETCHED_DISH_CATEGORIES',
	SET_TRANSITION_DISH_CATEGORY = 'SET_TRANSITION_DISH_CATEGORY',
	SET_FETCHED_DISH_SUB_CATEGORIES = 'SET_FETCHED_DISH_SUB_CATEGORIES',
	SET_TRANSITION_DISH_SUB_CATEGORY = 'SET_TRANSITION_DISH_SUB_CATEGORY',
	SET_FETCHED_DISHES = 'SET_FETCHED_DISHES',
	SET_TRANSITION_DISH_NAME = 'SET_TRANSITION_DISH_NAME',
	SET_FETCHED_GAME_CATEGORIES = 'SET_FETCHED_GAME_CATEGORIES',
	SET_TRANSITION_GAME_CATEGORY = 'SET_TRANSITION_GAME_CATEGORY',
	SET_FETCHED_GAMES = 'SET_FETCHED_GAMES',
	SET_TRANSITION_GAME_NAME = 'SET_TRANSITION_GAME_NAME',
	SET_CONTROL_POINT = 'SET_CONTROL_POINT',
	CHANGE_DELAY_TIME = 'CHANGE_DELAY_TIME',
	CHANGE_LAUNCH_COUNT = 'CHANGE_LAUNCH_COUNT',
	CHANGE_COUNTDOWN = 'CHANGE_COUNTDOWN',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateTeaserActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TCreateTeaserVisibleForm;
	};
}

interface ISetFile {
	type: CreateTeaserActionTypes.SET_FILE;
	payload: {
		fileId: TFileId;
		sourceUrlLocally: TSourceUrlLocally;
	};
}

interface ISetFetchedCustomers {
	type: CreateTeaserActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetCustomer {
	type: CreateTeaserActionTypes.SET_CUSTOMER;
	payload: {
		customer: TCreateTeaserSelectedItem;
	};
}

interface ISetFetchedRestaurants {
	type: CreateTeaserActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetRestaurants {
	type: CreateTeaserActionTypes.SET_RESTAURANTS;
	payload: {
		restaurants: string[];
	};
}

interface ISetContentType {
	type: CreateTeaserActionTypes.SET_CONTENT_TYPE;
	payload: {
		contentType: TCreateTeaserSelectedContentType;
	};
}

interface IChangeDescription {
	type: CreateTeaserActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: string;
	};
}

interface IChangeSchedule {
	type: CreateTeaserActionTypes.CHANGE_SCHEDULE;
	payload: {
		schedule: string;
	};
}

interface IChangeAdditionalSchedule {
	type: CreateTeaserActionTypes.CHANGE_ADDITIONAL_SCHEDULE;
	payload: {
		updatedSchedules: ICreateTeaserTotalSchedule[];
	};
}

interface ISetSchedules {
	type: CreateTeaserActionTypes.SET_SCHEDULES;
	payload: {
		updatedSchedules: ICreateTeaserTotalSchedule[];
	};
}

interface ISetTransitionType {
	type: CreateTeaserActionTypes.SET_TRANSITION_TYPE;
	payload: {
		transitionType: TCreateTeaserTransitionType;
	};
}

interface ISetFetchedDishCategories {
	type: CreateTeaserActionTypes.SET_FETCHED_DISH_CATEGORIES;
	payload: {
		dishCategories: IItemForGetShortInfo[];
	};
}

interface ISetTransitionDishCategory {
	type: CreateTeaserActionTypes.SET_TRANSITION_DISH_CATEGORY;
	payload: {
		transitionDishCategory: TCreateTeaserSelectedItem;
	};
}

interface ISetFetchedDishSubCategories {
	type: CreateTeaserActionTypes.SET_FETCHED_DISH_SUB_CATEGORIES;
	payload: {
		dishSubCategories: IItemForGetShortInfo[];
	};
}

interface ISetTransitionDishSubCategory {
	type: CreateTeaserActionTypes.SET_TRANSITION_DISH_SUB_CATEGORY;
	payload: {
		transitionDishSubCategory: TCreateTeaserSelectedItem;
	};
}

interface ISetFetchedDishes {
	type: CreateTeaserActionTypes.SET_FETCHED_DISHES;
	payload: {
		dishes: IItemForGetShortInfo[];
	};
}

interface ISetTransitionDishName {
	type: CreateTeaserActionTypes.SET_TRANSITION_DISH_NAME;
	payload: {
		transitionDishName: TCreateTeaserSelectedItem;
	};
}

interface ISetFetchedGameCategories {
	type: CreateTeaserActionTypes.SET_FETCHED_GAME_CATEGORIES;
	payload: {
		gameCategories: IItemForGetShortInfo[];
	};
}

interface ISetTransitionGameCategory {
	type: CreateTeaserActionTypes.SET_TRANSITION_GAME_CATEGORY;
	payload: {
		transitionGameCategory: TCreateTeaserSelectedItem;
	};
}

interface ISetFetchedGames {
	type: CreateTeaserActionTypes.SET_FETCHED_GAMES;
	payload: {
		games: IItemForGetShortInfo[];
	};
}

interface ISetTransitionGameName {
	type: CreateTeaserActionTypes.SET_TRANSITION_GAME_NAME;
	payload: {
		transitionGameName: TCreateTeaserSelectedItem;
	};
}

interface ISetControlPoint {
	type: CreateTeaserActionTypes.SET_CONTROL_POINT;
	payload: {
		controlPoint: TCreateTeaserControlPoint;
	};
}

interface IChangeDelayTime {
	type: CreateTeaserActionTypes.CHANGE_DELAY_TIME;
	payload: {
		delayTime: string;
	};
}

interface IChangeLaunchCount {
	type: CreateTeaserActionTypes.CHANGE_LAUNCH_COUNT;
	payload: {
		launchCount: string;
	};
}

interface IChangeCountDown {
	type: CreateTeaserActionTypes.CHANGE_COUNTDOWN;
	payload: {
		countDown: string;
	};
}

interface ISetDataForSubmit {
	type: CreateTeaserActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateTeaser | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateTeaserActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateTeaserModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateTeaserActionTypes.RESET_FIELDS;
}

export type TCreateTeaserAction =
	| IChangeVisibleForm
	| ISetFile
	| ISetFetchedCustomers
	| ISetCustomer
	| ISetFetchedRestaurants
	| ISetRestaurants
	| ISetContentType
	| IChangeDescription
	| ISetSchedules
	| IChangeSchedule
	| IChangeAdditionalSchedule
	| ISetTransitionType
	| ISetFetchedDishCategories
	| ISetTransitionDishCategory
	| ISetFetchedDishSubCategories
	| ISetTransitionDishSubCategory
	| ISetFetchedDishes
	| ISetTransitionDishName
	| ISetFetchedGameCategories
	| ISetTransitionGameCategory
	| ISetFetchedGames
	| ISetTransitionGameName
	| ISetControlPoint
	| IChangeDelayTime
	| IChangeLaunchCount
	| IChangeCountDown
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
